import { RetryLink } from 'apollo-link-retry'
import { handleUnauthorized } from '@/services/graphql/helpers'

export default new RetryLink({
	attempts: {
		max: 2,
		retryIf: handleUnauthorized,
	},
})
